import {
	HttpInterceptor,
} from 'utils/http';

export const userTimeInterceptor: HttpInterceptor<RequestInit> =
  async (url: string, request: RequestInit): Promise<RequestInit> => ({
  	...request,
  	headers: {
  		...request.headers,
  		'X-Device-Time': `${+new Date()}`,
  	},
  });